<template>
  <div class="text-[.385rem]">
    <Header :title="title" :showBack="true"></Header>
    <!-- 头部输入/选择框 -->
    <form action="" class="form_content">
      <div class="form_item">
        <span>班次时间：</span>
        <div class="form_input" @click.stop="$refs.calendar.show = true">
          {{ form.beginDate }} ~ {{ form.endDate }}
        </div>
      </div>
      <div class="form_item_special">
        <div class="form_item" style="width: 45%">
          <label>订单状态：</label>
          <div
            class="form_input text-row1"
            @click.stop="onOrderStatusSeleteShow"
          >
            {{ form.orderStatusName }}
          </div>
        </div>
      </div>
      <div class="form_item_special">
        <div class="form_item" style="width: 45%">
          <label>明细状态：</label>
          <div
            class="form_input text-row1"
            @click.stop="onOrderDetailStatusSeleteShow"
          >
            {{ form.orderDetailStatusName }}
          </div>
        </div>
      </div>
      <div class="form_item_special">
        <div class="form_item" style="width: 45%">
          <label>接驳类型：</label>
          <div
            class="form_input text-row1"
            @click.stop="onConnectTypeSeleteShow"
          >
            {{ form.connectTypeName }}
          </div>
        </div>
      </div>
      <div class="form_item_special">
        <div class="form_item" style="width: 45%">
          <label>线路：</label>
          <div class="form_input text-row1" @click.stop="onLineSelectShow">
            {{ form.lineNameList.toString() }}
          </div>
        </div>
      </div>
      <div class="form_item_special">
        <div class="form_item" style="width: 45%">
          <label>班次：</label>
          <div
            class="form_input text-row1"
            @click.stop="onLineClassDaySelectShow"
          >
            {{ form.classTime }}
          </div>
        </div>
      </div>
      <div class="form_item_special">
        <div class="form_item" style="width: 45%">
          <!-- <label>查询方式：</label> -->
          <input
            type="text"
            class="form_input"
            v-model="form.queryModleName"
            placeholder="  查询方式"
            @click.stop="onQueryModleSeleteShow"
          />
          <!-- <div
            class="form_input text-row1"
            @click.stop="onQueryModleSeleteShow"
          >
            {{ form.queryModle }}
          </div> -->
        </div>
        <div class="form_item" style="width: 45%">
          <!-- <label>查询条件：</label> -->
          <input
            type="text"
            class="form_input"
            v-model="form.condition"
            placeholder="  查询条件"
          />
        </div>
      </div>

      <div class="form_item_special">
        <div class="form_item" style="width: 45%">
          <van-checkbox
            v-model="form.isSearchEffectiveOrder"
            @click="onIsSearchEffectiveOrder"
            >只查询有效订单</van-checkbox
          >
        </div>
      </div>

      <button class="search_btn" type="button" @click="doQuery">查询</button>
    </form>
    <!-- 订单详情 -->
    <van-list
      class="m-1"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      :immediate-check="false"
      @load="onLoad"
      ref="list"
    >
      <!-- 订单面板 -->
      <div class="order_panel mt-1" v-for="(item, index) in list" :key="index">
        <div class="panel_index">{{ index + 1 }}</div>
        <div class="panel_item">
          <div class="panel_item_content">
            <p class="item_content_label">班次时间:</p>
            <p class="item_content_info info_title flex-1">
              {{ item.ClassDateTime }}
            </p>
          </div>
          <div class="panel_item_content">
            <p class="item_content_label">接送时间:</p>
            <p class="item_content_info info_title flex-1">
              {{ item.PickUpDateTime }}
            </p>
          </div>
          <div class="panel_item_content">
            <p class="item_content_label">线路名称:</p>
            <div class="item_content_info info_title flex-1">
              {{ item.LineName }}
            </div>
          </div>
          <div class="panel_item_content">
            <p class="item_content_label">站点名称:</p>
            <div class="item_content_info flex-1">
              {{ item.OrderNodeName }}
            </div>
          </div>
          <div class="panel_item_content">
            <p class="item_content_label">接驳上车点信息:</p>
            <p class="item_content_info flex-1">
              上车点：{{ item.ConnectStartNodeName }} <br />
              上车点地址：{{ item.ConnectStartNodeAddress }}
            </p>
          </div>
          <div class="panel_item_content">
            <p class="item_content_label">接驳下车点信息:</p>
            <p class="item_content_info flex-1">
              下车点：{{ item.ConnectArrivalNodeName }} <br />
              下车点地址：{{ item.ConnectArrivalNodeAddress }}
            </p>
          </div>
          <div class="panel_item_content">
            <p class="item_content_label">乘车人:</p>
            <p class="item_content_info flex-1">{{ item.CustName }}</p>
            <p class="item_content_label phone_label_width">电话:</p>
            <p
              @click="callPhoneNumber(item)"
              class="item_content_info info_title flex-1"
            >
              {{ item.CustTel }}
            </p>

            <!-- <a
              class="item_content_info info_title flex-1"
              :href="'tel:' + item.CustTel"
              >{{ item.CustTel }}</a
            > -->
          </div>

          <div
            class="panel_item_content"
            v-if="showAll && index === activeIndex"
          >
            <p class="item_content_label">明细原价:</p>
            <p class="item_content_info flex-1">
              {{ item.OrginPrice }}
            </p>
          </div>
          <div
            class="panel_item_content"
            v-if="showAll && index === activeIndex"
          >
            <p class="item_content_label">明细价格:</p>
            <p class="item_content_info flex-1">
              {{ item.Price }}
            </p>
          </div>
          <div
            class="panel_item_content"
            v-if="showAll && index === activeIndex"
          >
            <p class="item_content_label">平台类型:</p>
            <p class="item_content_info flex-1">
              {{ item.PlateCodeName }}
            </p>
          </div>
          <div
            class="panel_item_content"
            v-if="showAll && index === activeIndex"
          >
            <p class="item_content_label">支付成功时间:</p>
            <p class="item_content_info flex-1">
              {{ item.PaySuccessTime }}
            </p>
          </div>
          <div
            class="panel_item_content"
            v-if="showAll && index === activeIndex"
          >
            <p class="item_content_label">留言备注:</p>
            <p class="item_content_info flex-1">
              {{ item.Remark }}
            </p>
          </div>
          <div
            class="panel_item_content"
            v-if="showAll && index === activeIndex"
          >
            <p class="item_content_label">明细状态:</p>
            <p class="item_content_info flex-1">
              {{ item.OrderDetailStatusName }}
            </p>
          </div>
          <div
            class="panel_item_content"
            v-if="showAll && index === activeIndex"
          >
            <p class="item_content_label">接送订单号:</p>
            <p class="item_content_info flex-1">{{ item.OrderNo }}</p>
          </div>
          <div
            class="panel_item_content"
            v-if="showAll && index === activeIndex"
          >
            <p class="item_content_label">接驳类型:</p>
            <p class="item_content_info flex-1">{{ item.ConnectTypeName }}</p>
          </div>
          <div
            class="panel_item_content"
            v-if="showAll && index === activeIndex"
          >
            <p class="item_content_label">用时（分钟）:</p>
            <p class="item_content_info flex-1">
              {{ item.Duration }}
            </p>
          </div>
          <div
            class="panel_item_content"
            v-if="showAll && index === activeIndex"
          >
            <p class="item_content_label">距离（米）:</p>
            <p class="item_content_info flex-1">
              {{ item.Distance }}
            </p>
          </div>
          <div
            class="panel_item_content"
            v-if="showAll && index === activeIndex"
          >
            <p class="item_content_label">车票订单号:</p>
            <p class="item_content_info flex-1">
              {{ item.TicketOrderNo }}
            </p>
          </div>

          <div class="panel_item_content">
            <van-button size="large" @click="showAllFields(index)">{{
              showAll && index === activeIndex ? "收起" : "更多"
            }}</van-button>
          </div>
        </div>
      </div>
    </van-list>
    <div class="fab">
      <van-button v-if="showBackToTop" @click="goToTop">回到顶部</van-button>
    </div>

    <!-- 日历组件 -->
    <Calendar
      ref="calendar"
      type="range"
      :allow-same-day="true"
      @confirm="onConfirm"
    ></Calendar>

    <!--订单状态弹窗 -->
    <van-popup
      v-model="orderStatusShow"
      round
      position="bottom"
      :style="{ height: '90%' }"
    >
      <van-picker
        title="订单状态"
        show-toolbar
        :columns="orderStatusList"
        @cancel="onCancelStatus"
        @confirm="onSelectStatus"
        value-key="CodeName"
      />
    </van-popup>

    <!--明细状态弹窗 -->
    <van-popup
      v-model="orderDetailStatusShow"
      round
      position="bottom"
      :style="{ height: '90%' }"
    >
      <van-picker
        title="明细状态"
        show-toolbar
        :columns="orderDetailStatusList"
        @cancel="onCancelDetailStatus"
        @confirm="onSelectDetailStatus"
        value-key="CodeName"
      />
    </van-popup>

    <!-- 接驳类型弹窗 -->
    <van-popup
      v-model="connectTypeShow"
      round
      position="bottom"
      :style="{ height: '90%' }"
    >
      <van-picker
        title="接驳类型"
        show-toolbar
        :columns="connectTypeList"
        @cancel="onCancelConnectType"
        @confirm="onSelectConnectType"
        value-key="connectTypeName"
      />
    </van-popup>

    <!-- 查询方式弹窗 -->
    <van-popup
      v-model="queryModleShow"
      round
      position="bottom"
      :style="{ height: '90%' }"
    >
      <van-picker
        title="查询方式"
        show-toolbar
        :columns="queryModleList"
        @cancel="onCancelQueryModle"
        @confirm="onSelectQueryModle"
        value-key="queryModleName"
      />
    </van-popup>

    <!-- 线路弹窗 -->
    <van-popup
      v-model="lineShow"
      round
      position="bottom"
      :style="{ height: '90%' }"
    >
      <van-checkbox-group v-model="form.lineGIDList">
        <van-checkbox
          :name="item.LineGID"
          shape="square"
          v-for="(item, index) in lineList"
          :key="index"
          >{{ item.LineName }}</van-checkbox
        >
      </van-checkbox-group>
      <van-button
        class="w100"
        type="default"
        block
        color="#33ccff"
        size="small"
        @click="onSelectLine"
        >确认</van-button
      >
    </van-popup>

    <!-- 班次弹窗 -->
    <van-popup
      v-model="lineClassDayShow"
      round
      position="bottom"
      :style="{ height: '90%' }"
    >
      <van-picker
        title="班次"
        show-toolbar
        :columns="lineClassDayList"
        @cancel="onCancelLineClassDay"
        @confirm="onSelectLineClassDay"
        value-key="ClassTime"
      />
    </van-popup>
  </div>
</template>

<script>
import Header from "@/components/Header/Header";
import Calendar from "../../components/calendar.vue";
export default {
  components: {
    Header,
    Calendar,
  },
  data() {
    return {
      title: "接驳订单",
      operObj: JSON.parse(window.localStorage.getItem("adminInfo")),
      loading: false,
      finished: false,
      form: {
        beginDate: this.$moment().format("YYYY-MM-DD"),
        endDate: this.$moment().format("YYYY-MM-DD"),
        lineNameList: [],
        lineGIDList: [],

        orderStatusID: "",
        orderStatusName: "",
        orderDetailStatusID: "",
        orderDetailStatusName: "",
        connectTypeID: "",
        connectTypeName: "",
        queryModleID: "",
        queryModleName: "",

        queryModle: "",
        condition: "",
        lineClassDayGID: "",
        classTime: "", //lineClassDayGID 的显示字段

        isSearchEffectiveOrder: true,
      },
      start: 0,
      limit: 5,
      list: [],
      showAll: false,
      activeIndex: null,
      buttonText: "更多",

      lineShow: false,
      lineList: [],
      lineClassDayShow: false,
      lineClassDayList: [],
      connectTypeShow: false,
      connectTypeList: [],
      orderDetailStatusShow: false,
      orderDetailStatusList: [],
      orderStatusShow: false,
      orderStatusList: [],
      queryModleShow: false,
      queryModleList: [],
      showBackToTop: false,
    };
  },
  created() {
    //this.clickOrderSourcePopupShow();
  },
  methods: {
    onIsSearchEffectiveOrder() {
      this.isSearchEffectiveOrder = !this.isSearchEffectiveOrder;
    },

    showAllFields(index) {
      this.activeIndex = index;
      this.showAll = !this.showAll;
    },

    callPhoneNumber(item) {
      //获取车票手机号码
      var flag = this.$utils.isPhone(item.CustTel);

      if (flag) {
        window.location.href = "tel:" + item.CustTel;
        return;
      }
      this.$http
        .post(
          this.$api.onTicketCustDetailQuery,
          this.$qs.stringify({
            TicketOrderDetailGID: item.TicketOrderDetailGID,
          })
        )
        .then((res) => {
          if (res.success) {
            window.location.href = "tel:" + res.data[0].CustTel;
            //alert(res.data[0].CustTel);
          }
        });
    },

    handleScroll() {
      this.showBackToTop = window.scrollY > 200; // 当滚动超过200px时显示按钮
    },
    goToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" }); // 平滑滚动到顶部
    },

    // 订单状态选择函数
    async onOrderStatusSeleteShow() {
      if (this.orderStatusList.length <= 0) {
        await this.$http
          .post(this.$api.getCoreSysDictionaryCode, {
            CodeType: "ConnectOrderStatus",
          })
          .then((res) => {
            this.orderStatusList = res.data;
          });
      }
      this.orderStatusShow = true;
    },

    // 明细状态选择函数
    async onOrderDetailStatusSeleteShow() {
      if (this.orderDetailStatusList.length <= 0) {
        await this.$http
          .post(this.$api.getCoreSysDictionaryCode, {
            CodeType: "ConnectOrderDetailStatus",
          })
          .then((res) => {
            this.orderDetailStatusList = res.data;
          });
      }
      this.orderDetailStatusShow = true;
    },

    // 接驳类型选择函数
    async onConnectTypeSeleteShow() {
      if (this.connectTypeList.length <= 0) {
        this.connectTypeList = [
          { connectTypeID: 1, connectTypeName: "上车点接驳" },
          { connectTypeID: 2, connectTypeName: "下车点接驳" },
        ];
      }
      this.connectTypeShow = true;
    },

    // 查询方式选择函数
    async onQueryModleSeleteShow() {
      if (this.queryModleList.length <= 0) {
        this.queryModleList = [
          { queryModleID: "TicketOrderNo", queryModleName: "车票订单号" },
          { queryModleID: "OrderNo", queryModleName: "接驳订单号" },
          { queryModleID: "ConnectTaskNo", queryModleName: "接驳任务单号" },
          { queryModleID: "CustName", queryModleName: "乘车人姓名" },
          { queryModleID: "CustTel", queryModleName: "乘车人手机号" },
        ];
      }

      this.queryModleShow = true;
    },

    // 线路选择函数
    async onLineSelectShow() {
      if (this.lineList.length <= 0) {
        await this.$http
          .post(this.$api.getGetCompLine, {
            OrganizationGID: this.operObj.OrganizationGID,
          })
          .then((res) => {
            this.lineList = res.data;
          });
      }
      this.lineShow = true;
    },

    // 班次选择函数
    async onLineClassDaySelectShow() {
      //oys 2025-02-19 10:05 庞发友要求 “不选线路就不能选班次然后给个提示:请先选择线路，选了线路之后只显示这条线路的班次”
      if (this.form.lineNameList.length <= 0) {
        this.$dialog.alert({
          title: "提示",
          message: "请先选择线路",
        });
        return;
      }

      if (this.form.lineNameList.length > 0) {
        await this.$http
          .post(this.$api.getLineClassDay, {
            LineGIDList: this.form.lineGIDList,
            OrganizationGID: JSON.parse(
              window.localStorage.getItem("adminInfo")
            ).OrganizationGID,
            BeginDate: this.$moment(new Date()).format("YYYY-MM-DD"),
            EndDate: this.$moment(new Date()).format("YYYY-MM-DD"),
            CompGID: JSON.parse(window.localStorage.getItem("adminInfo"))
              .CompGID,
          })
          .then((res) => {
            this.lineClassDayList = res.data;
          });
      }
      this.lineClassDayShow = true;
    },

    // 查询按钮函数
    doQuery() {
      //console.log(this.form);

      this.list = [];
      this.start = 0;
      this.finished = false;
      this.$nextTick(() => this.$refs.list.check());
      // this.onLoad();
    },

    // 取消订单状态函数
    onCancelStatus() {
      this.form.orderStatusName = "";
      this.form.orderStatusID = "";

      this.orderStatusShow = false;
    },

    // 确认订单状态函数
    onSelectStatus(value) {
      this.form.orderStatusName = value.CodeName;
      this.form.orderStatusID = value.CodeFlag;

      this.orderStatusShow = false;
    },

    // 取消明细状态函数
    onCancelDetailStatus() {
      this.form.orderDetailStatusName = "";
      this.form.orderDetailStatusID = "";

      this.orderDetailStatusShow = false;
    },

    // 确认明细状态函数
    onSelectDetailStatus(value) {
      this.form.orderDetailStatusName = value.CodeName;
      this.form.orderDetailStatusID = value.CodeFlag;

      this.orderDetailStatusShow = false;
    },

    // 取消接驳类型函数
    onCancelConnectType() {
      this.form.connectTypeName = "";
      this.form.connectTypeID = "";

      this.connectTypeShow = false;
    },

    // 确认接驳类型函数
    onSelectConnectType(value) {
      this.form.connectTypeName = value.connectTypeName;
      this.form.connectTypeID = value.connectTypeID;

      this.connectTypeShow = false;
    },

    // 取消查询方式函数
    onCancelQueryModle() {
      this.form.queryModleName = "";
      this.form.queryModleID = "";

      this.queryModleShow = false;
    },

    // 确认查询方式函数
    onSelectQueryModle(value) {
      this.form.queryModleName = value.queryModleName;
      this.form.queryModleID = value.queryModleID;

      this.queryModleShow = false;
    },

    // 确认线路函数
    onSelectLine() {
      this.form.lineNameList = this.lineList
        .filter((v) => this.form.lineGIDList.some((g) => g == v.LineGID))
        .map((v) => v.LineName);

      //oys 2025-02-20 9:48 处理选择线路之后，班次清空问题
      if (this.form.lineNameList.length <= 0) {
        this.onCancelLineClassDay();
      }

      this.lineShow = false;
    },

    // 取消班次函数
    onCancelLineClassDay() {
      this.form.classTime = "";
      this.form.lineClassDayGID = "";

      this.lineClassDayShow = false;
    },

    // 确认班次函数
    onSelectLineClassDay(value) {
      this.form.classTime = value.ClassTime;
      this.form.lineClassDayGID = value.GID;

      this.lineClassDayShow = false;
    },

    // 日历确认函数
    onConfirm(e) {
      this.form.beginDate = this.$moment(e[0]).format("YYYY-MM-DD");
      this.form.endDate = this.$moment(e[1]).format("YYYY-MM-DD");
    },

    onLoad() {
      const params = {
        //_CompGID: null, //oys 本地调试使用，更新记得注释
        BeginDate: this.$moment(this.form.beginDate).format(
          "YYYY-MM-DD 00:00:00"
        ),
        EndDate: this.$moment(this.form.endDate).format("YYYY-MM-DD 23:59:59"),
        LineGIDList: this.form.lineGIDList.toString(),
        OrderStatus: this.form.orderStatusID,
        OrderDetailStatus: this.form.orderDetailStatusID,
        ConnectTypeID: this.form.connectTypeID,
        QueryModle: this.form.queryModleID,
        Condition: this.form.condition,
        IsSearchEffectiveOrder: this.form.isSearchEffectiveOrder,
        LineClassDayGID: this.form.lineClassDayGID,
        start: this.start,
        limit: this.limit,
      };
      this.$http.post(this.$api.getTicketConnectOrder, params).then((res) => {
        if (res.success) {
          const total = res.total;
          res.data.forEach((item) => {
            item.ClassDateTime =
              item.ClassDateTime &&
              this.$moment(item.ClassDateTime).format("YYYY-MM-DD HH:mm:ss");
            item.PickUpDateTime =
              item.PickUpDateTime &&
              this.$moment(item.PickUpDateTime).format("YYYY-MM-DD HH:mm:ss");
            item.CreateTime =
              item.CreateTime &&
              this.$moment(item.CreateTime).format("YYYY-MM-DD HH:mm:ss");
            item.PaySuccessTime =
              item.PaySuccessTime &&
              this.$moment(item.PaySuccessTime).format("YYYY-MM-DD HH:mm:ss");
            this.list.push(item);
          });
          this.start += this.limit;
          this.loading = false;
          if (this.list.length >= total) {
            this.finished = true;
          }
        }
      });
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="less" scoped>
.fab {
  position: fixed;
  right: 16px;
  bottom: 16px;
  z-index: 100; /* 确保按钮在页面其他内容之上 */
}
.form_content {
  padding-bottom: 15px;
  background-color: #fff;
  // 日期
  .form_item {
    display: flex;
    flex: 1;
    padding: 0.256rem;
    line-height: 0.75rem;
    box-sizing: border-box;
    & > input {
      width: 100%;
      border: none;
    }
    .date_split {
      margin: 0 0.256rem;
    }
    .form_input {
      border-bottom: 1px solid #000;
      min-width: 2.692rem;
      flex: 1;
      font-size: 0.359rem;
    }
    .van-button {
      flex: 1;
      margin-left: 0.128rem;
    }
  }
  .form_item_special {
    display: flex;
  }
  .search_btn {
    width: 40%;
    padding: 0.15rem;
    background-color: #33ccff;
    margin-top: 0.1rem;
    margin-left: 0.128rem;
    color: white;
    border-radius: 3px;
  }
  .form_item_column {
    .form_item {
      display: flex;
      .title {
        min-width: 2rem;
        text-align: left;
      }
      .van-checkbox {
        margin-bottom: 0.2rem;
      }
    }
    .button {
      padding: 0 0.3rem;
      text-align: right;
      & > :nth-child(1) {
        margin-right: 0.3rem;
        color: #33ccff;
      }
    }
  }
}
.order_panel {
  border-radius: 10px;
  padding: 0.15rem;
  background-color: #fff;
  text-align: left;
  position: relative;
  .panel_index {
    width: 0.5333rem;
    height: 0.5333rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.32rem;
    text-align: center;
    color: #fff;
    background-color: #f7a33c;
    border-radius: 50%;
    position: absolute;
    top: 3px;
    left: 3px;
  }
  .panel_item {
    .panel_item_content {
      display: flex;
      line-height: 0.5rem;
      min-height: 1rem;
      .item_content_label {
        width: 2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #d8d8d8;
        background-color: #f9f9f9;
      }
      .item_content_info {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border: 1px solid #d8d8d8;
        padding: 0 5px;
        .info_btn {
          padding: 3px 3px;
          border-radius: 5px;
          color: #fff;
        }
        & > span {
          color: #000;
        }
      }
      .info_title {
        color: #fe6500;
      }
      .phone_label_width {
        width: 15%;
      }
    }
  }
}
.van-popup {
  .van-checkbox {
    margin: 0.267rem;
  }

  .van-button {
    font-size: 0.533rem;
  }
}
.order-source-popup {
  padding: 0.3rem;
  .order-source-popup-input {
    margin-bottom: 0.3rem;
  }
  .order-source-popup-clear {
    color: #33ccff;
    text-align: left;
    margin-bottom: 0.3rem;
  }
  .order-source-popup-radio {
    width: 100%;
    margin-bottom: 0.3rem;
    .popup-radio-item {
      margin-bottom: 0.2rem;
    }
  }
}
</style>
